<template>
  <v-card
    tile
    flat
    v-if='wo'
    class='my-0 py-0'
    @mouseover='hover = true'
    @mouseleave='hover = false'
  >
    <div class='wo-tile' :class="woClass">
      <div class='selected-bar' :class='selectedStatus'></div>
      <div class='top-row'>
        <!-- top-row-items is an extra layer so that the whole top row area (other than the icons) can be used to select the wotile -->
        <div class='top-row-items' @click='woClicked'>
          <div class='wo-type'>
            <v-badge dot inline :color='woType.color'></v-badge>
          </div>
          <div class='name wo-name'>
            {{ wo.project_name }}
          </div>
        </div>
        <div class='icons'>
          <v-btn x-small v-if='wo.has_crew_visits' icon class='icon' @click='openCrewVisits'>
            <v-icon small :color="wo.is_attempted ? 'warning' : ''">{{ crewIcon.icon }}</v-icon>
          </v-btn>
          <v-icon x-small class='icon' color='primary' v-if="wo.project_needs_key">mdi-key-variant</v-icon>
          <v-icon small class='icon' v-if="wo.priority === 2">mdi-alert</v-icon>
          <v-icon small class='icon' v-if="wo.priority === 1">mdi-exclamation-thick</v-icon>
          <v-icon small class='icon' v-if="wo.call_mins_ahead">mdi-phone</v-icon>
          <v-icon small class='icon' v-if="wo.is_hose_bib">mdi-water-pump</v-icon>
          <div style="display: flex, flex-direction: row"  v-if="wo.has_charged_hose_bib">
            <v-icon class='icon' style="padding-right: 0, padding-left: 0">mdi-alpha-h</v-icon>
            <v-icon class='icon' style="margin-left: -15px">mdi-alpha-b</v-icon>
          </div>
          <div style="display: flex, flex-direction: row" v-if="wo.has_charged_feature">
            <v-icon class='icon' style="padding-right: 0, padding-left: 0">mdi-alpha-w</v-icon>
            <v-icon class='icon' style="margin-left: -15px">mdi-alpha-f</v-icon>
          </div>
          <v-icon small class='icon' >mdi-phone</v-icon>

          <v-tooltip top v-if='wo.apt_date && !wo.apt_time' :disabled='!isScheduleConflict'>
            <template v-slot:activator='{ on }'>
              <v-icon
                v-on='on'
                v-if='wo.apt_date'
                small
                :color='isScheduleConflict ? "error" : ""'
              >
              <!-- at some point, we may want this icon to open the schedule considerations dialog directly. -->
                mdi-calendar
              </v-icon>
            </template>
            <span class='caption'>Warning - This WO is scheduled for {{ wo.apt_date | shortDateNoYear }}!</span>
          </v-tooltip>

          <v-tooltip top v-if='!!wo.apt_time' :disabled='!isScheduleConflict'>
            <template v-slot:activator='{ on }'>
              <v-icon
                v-on='on'
                v-if='!!wo.apt_time'
                small
                :color='isScheduleConflict ? "error" : ""'
              >
                mdi-clock
              </v-icon>
            </template>
            <span class='caption'>Warning - This WO is scheduled for {{ wo.apt_date | shortDateNoYear }}!</span>
          </v-tooltip>

          <v-btn x-small icon @click='openQuickView'>
            <v-icon small :color='help_color'>{{ wo.on_hold ? $icons.hold.icon : "mdi-help-circle-outline"}}</v-icon>
          </v-btn>
          <v-btn v-if='shouldShowInsertBox' x-small icon :disabled='isLoading' @click="$emit('insertBefore', wo)">
            <v-icon color='error'>mdi-arrow-up-bold</v-icon>
          </v-btn>
        </div>
      </div>
      <div class='bottom-row' @click='woClicked'>
        <div class='address wo-detail'>
          {{ wo.project_site_address }},
        </div>
        <div class='city wo-detail'>
          {{ wo.project_site_city }}
        </div>
        <div class='timeline wo-detail' :style='timelineStyle' v-if='wo.timeline !== "NTL"'>
          {{ wo.timeline }}
        </div>
        <div class='route wo-detail'>
          {{ wo.project_route_group }}{{wo.project_route_number }}
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>

export default {
  name: 'wo-tile',
  props: {
    wo: {
      required: true
    },
    hideInsertArrows: {
      required: false,
      type: Boolean,
      default: false
    },
    showInsertBox: {
      required: true
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: false
    },
    routeDate: {
      required: false
    }
  },
  data: () => ({
    hover: false,
    completedColor: 'green lighten-4 ',
    attemptedColor: 'orange lighten-4 '
  }),
  computed: {
    help_color(){
      if(this.wo.project_call_ahead && this.woType.category === 'SU'){
        return 'blue';
      }
      else if(this.wo.bd_call_ahead && this.woType.category === 'BD'){
        return 'blue';
      }
      else if(this.wo.project_call_ahead && this.woType.category === 'LC'){
        return 'blue';
      }
      else if(this.wo.project_call_ahead && this.woType.category === 'FW'){
        return 'blue';
      }
      else if(this.wo.project_call_ahead && this.woType.category === 'SC'){
        return 'blue';
      }
      else if(this.wo.scheduling_considerations || this.wo.project_scheduling_considerations || this.wo.on_hold){
        return 'error';
      }
      return '';
    },
    selectedStatus () {
      if (this.wo.is_selected) {
        return 'error'
      } else if (this.wo.is_complete) {
        return this.completedColor
      } else if (this.wo.is_attempted) {
        return this.attemptedColor
      } else {
        return 'white'
      }
    },
    woClass() {
      if (this.wo.is_complete) {
        return this.completedColor
      } else if (this.wo.is_attempted) {
        return this.attemptedColor
      } else {
        return ""
      }
    },
    woType () {
       return this.wo ? this.$store.state.misc.woTypes.find(t => t.id === this.wo.wo_type) : ''
    },
    shouldShowInsertBox () {
      return this.hover && this.showInsertBox && !this.wo.is_selected
    },
    crewIcon () {
      return this.$store.state.icons.dataBox.crewVisits
    },
    timelineStyle () {
      let style = ''
      switch (this.wo.timeline) {
        case 'BM8':
          style = 'color: red;'
          break
        case 'ERS10':
          style = 'color: yellow'
          break
        case 'AS6':
          style = 'color: #cc66ff;'
          break
        case 'AS20':
          style = 'color: #4b749c;'
          break
        case 'AO1':
          style = 'color: #a15524;'
          break
        default:
          style = 'color: purple;'
      }
      return style
    },
    isScheduleConflict() {
      if (this.routeDate && this.wo.apt_date) {
        return this.wo.apt_date !== this.routeDate
      }
      return false
    },
    officeAlert () {
      return !!this.wo.scheduling_considerations || !!this.wo.project_scheduling_considerations || this.wo.on_hold
    }
  },
  methods: {
    woClicked () {
      if (!this.wo.is_complete) {
        this.$emit('woClicked', this.wo)
      }
    },
    openQuickView () {
      this.$emit('openQuickView', this.wo)
    },
    openCrewVisits () {
      this.$emit('openCrewVisits', this.wo)
    }
  }
}
</script>

<style scoped>

.wo-tile {
  display: grid;
  grid-template-columns: 5px 1fr;
  grid-template-rows: 19px 13px;
  cursor: pointer;
}

.selected-bar {
    grid-row: 1 / span 2;
}

.top-row {
    grid-column: 2 / -1;
    display: flex;
    overflow: hidden;
}

.bottom-row {
    grid-column: 2 / -1;
    display: flex;
    align-items: flex-end;
    overflow: hidden;
}

.top-row-items {
/* top row items includes the wotype badge and name but extends all the way to the first icon */
/* so it included the names' auto right margin which would otherwise be unclickable */
    display: flex;
    align-items: center;
    margin-right: auto;
    overflow: hidden;
    flex: 1;

}

.icons {
    display: flex;
    align-items: center;
}

.wo-type {
  margin-bottom: 1px;
}

.icon {
  margin-left: 1px;
}

.city {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
    min-width: 25px;
    margin-right: auto;
    margin-left: 5px;
    flex-shrink: 100000;
    /* the large value here ensures the city field shrinks first before address gains ellipsis */
}

.name {
    margin-left: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.address {
    margin-left: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.route {
  white-space: nowrap;
  margin-left: 5px;
  margin-right: 3px;
}

.wo-name {
  font-size: 12px;
  font-weight: 700;
}

.wo-detail {
  font-size: 11px;
  color: grey;
}

.timeline {
  font-size: 10px;
  font-weight: 700;
}

</style>
